module.exports = __webpack_public_path__ + "static/images/c60b9e578f0064647591d3d4c2f85855.webp";